// extracted by mini-css-extract-plugin
export default {"container":"LottieAnimationLayer_container__D2UWD","isLoaded":"LottieAnimationLayer_isLoaded__kaiv3"};